// dependencies
import React from 'react'
import { Button as RebassButton } from 'rebass'

// components
import Translate from 'App/components/text/Translate.js'

class Button extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
    }
  }

  render () {
    return (
      <RebassButton {...this.props}>
        <Translate>{this.props.children}</Translate>
      </RebassButton>
    )
  }
}
export default Button
